import { Component, OnInit, ViewChild, HostListener } 			from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} 	from '@angular/forms';
import {ErrorStateMatcher} 										from '@angular/material/core';

import { Router, ActivatedRoute } 								from '@angular/router';
import { first } 												from 'rxjs/operators';

import swal,{ SweetAlertOptions }                                 from 'sweetalert2';
import { SwalComponent }                                          from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } 					from '../_services';
import { Globals}                                               from '../_helpers';

import { NgxSpinnerService }                                    from 'ngx-spinner';

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	    const isSubmitted = form && form.submitted;
	    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}


@Component({
  selector: 'assessor-login',
  templateUrl: './login.component.html'
})


export class LoginComponent implements OnInit {
    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;

    public alertOption:SweetAlertOptions = {};

	usernameFormControl = new FormControl('', [
	    Validators.required,
	]);
	passwordFormControl = new FormControl('', [
	    Validators.required,
	]);
  	matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg : string;
    returnUrl: string;
    isReset = false;
    isShowPass = true;
    resetMsg : string;
    hide=true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService

    ) {}


    ngOnInit() {
        /* clear loaclStorege */
        localStorage.clear();
        
        /* reset login status */
        this.authenticationService.logout(this.globals.root_url);

        /* get return url from route parameters or default to '/' */
        this.returnUrl = '/';
    }

/*    ngAfterViewInit(){
        this.detectBrowserSuport();
    }*/

    onSubmit() {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.usernameFormControl.value == '' || this.passwordFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else{
            this.loading = true;
            this.spinner.show();
            this.authenticationService.login(this.globals.root_url, this.usernameFormControl.value, this.passwordFormControl.value)
            .pipe(first())
            .subscribe(
    	        data => {
                    if(data.code == 1000){
                        this.isErrorLogin = false;
                        let settings = data.settings;
                        let examId = 0;
                        if(typeof settings.exam_id !=  'undefined' && settings.exam_id)
                            examId = settings.exam_id;
            
                        localStorage.setItem('currentUser', JSON.stringify({id:data.id, usercode:data.usercode, exam_id:examId,viva_assessor:settings.viva_assessor, name_assessor:data.name}));
                        var parms = this.globals.getRandUrl('dashboard');
                        localStorage.setItem('urlStep', JSON.stringify({set:parms}));
                        this.router.navigateByUrl('/dashboard/'+parms);
                     
                    }
                    else{
                        this.isErrorLogin = true;
                        this.errorMsg = 'Invalid username or password !!';
                        this.loading = false;
                    }
                    this.spinner.hide();
    	        },
    	        error => {
                    this.isErrorLogin = true;
                    this.errorMsg = 'Invalid username or password !!';
    	            this.alertService.error(error);
    	            this.loading = false;
                    this.spinner.hide();
    	        }
    	    );
        }
    }

    forgotPass(){
        this.isShowPass = false;
        if (this.usernameFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else{
            this.spinner.show();
            this.authenticationService.resetPassword(this.globals.root_url, this.usernameFormControl.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.isShowPass = true;
                    if(data.code == 1000){
                        this.isReset = true;
                        this.resetMsg = data.status;
                    }
                    else{
                        this.isReset = true;
                        this.resetMsg = data.status;
                    }
                    this.spinner.hide();
                },
                error => {
                    this.isShowPass = true;
                    this.alertService.error(error);
                    this.isReset = true;
                    this.spinner.hide();
                }
            );
        }
    }

    showPass(){
        this.isShowPass = false;
    }
    showLogin(){
        this.isShowPass = true;
    }


    private detectBrowserSuport(){
        let isSupport = true;
        let video = document.createElement('video');
        if(video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if(video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if(video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if(video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if(audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if(audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if(!isSupport){
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else{
            console.log('ok');
        }

    }
}

